import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import UrlEncode from '../assets/js/UrlEncode.js' 

// Vue.prototype.$UrlEncode = UrlEncode;
Vue.use(VueRouter)

const routes = [
  {
    path: '/Home',
    name: 'Home',
    component: Home,
    // query:{
    //   key:Vue.prototype.$UrlEncode.encode(JSON.stringify({
    //     sportID:'',
    //     phaseID: '',
    //     phaseName: '',
    //     sportName: '',
    //   }))
    // }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/HomeRank',
    name: 'HomeRank',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/home/HomeRank.vue')
  },
  {
    path: '/GameMatch',
    name: 'GameMatch',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/game/GameMatch.vue')
  },
  {
    path: '/PoolResult',
    name: 'PoolResult',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/result/PoolResult.vue')
  },
  {
    path: '/BestTeam',
    name: 'BestTeam',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/statistical/BestTeam.vue')
  },
  {
    path: '/TeamConstitute',
    name: 'TeamConstitute',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/team/TeamConstitute.vue')
  },
  {
    path:"*",
    redirect:'/Home',
    meta: {
      authen: false
    }
  },
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes
})

// router.beforeEach((to, from, next) => {
//   console.log(to)
//   console.log(from)
//   // console.log(next())
//   // console.log(checkSportID)
//   // key:this.$UrlEncode.encode(JSON.stringify({
//     //         sportID: SportID,
//     //         phaseID: PhaseID,
//     //         phaseName: phaseName,
//     //         sportName: '这是不是',
//     //       }))
//   //判断该页面有channel
//   if(from.query.key){
//       //路由切换时，如果没有就添加，有就跳过执行，添加固定参数
//       if (!to.query.key) {
//           //准备一个跳转的query对象
//           let query = to.query
//           query.key = from.query.key
//           next({
//             path: to.path,
//             query: query
//           })
//       } else {
//           next()
//       }
//   }else{
//       next()
//   }

// })

export default router
